import { useMutation, useQueryClient } from "@tanstack/react-query";
import homepageApi, { HOMEPAGE_KEY } from "../../api/homepageApi";

export const useUpdateTextHomepage = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ description, id }: { description: string; id: string }) =>
            homepageApi.updateText(description, id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: HOMEPAGE_KEY });
        },
    });
};